import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import useScrollReveal from "@/hooks/useScrollReveal";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { Impressum } from "@/components/LegalSections";

export default function ImpressumPage({ onOpenCookieSettings }) {
  useScrollReveal();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div data-testid="impressum-page">
      <Navbar onOpenCookieSettings={onOpenCookieSettings} />
      <main className="pt-24" style={{ background: "var(--cream)" }}>
        <div className="max-w-4xl mx-auto px-6 lg:px-10 pt-6">
          <Link
            to="/"
            data-testid="back-to-home"
            className="inline-flex items-center gap-2 text-sm soft-link"
            style={{ color: "var(--ink-soft)" }}
          >
            <ArrowLeft size={16} />
            Zurück zur Startseite
          </Link>
        </div>
        <Impressum />
      </main>
      <Footer onOpenCookieSettings={onOpenCookieSettings} />
    </div>
  );
}
